import { default as BackgroundImage } from './background-image';
export default BackgroundImage;
